import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import "./Conersations.css";
import chatIcon from "../../assets/img/chatIcon.png";
import filterIcon from "../.././assets/img/filtericon.svg";
import history from "../../routes/history";
import {
  Dropdown,
  Menu,
  Row,
  Col,
  Input,
  Skeleton,
  Button,
  Radio,
  Space,
} from "antd";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import ConversationCard from "./components/Messages/ConversationCard";
import FilterConversations from "./components/Filters/Filter";
import { ChatCard } from "./components/ChatCard/ChatCard";
import { useDispatch, useSelector } from "react-redux";
import FeatureGate from "../FeatureGate/FeatureGate";
import Loader from "../../components/Loading/Loader";
import { debounce, formatPhoneNumber, setCookie } from "../../shared/helpers";
import {
  fetchInboxMessages,
  receivedMessage,
  fetchNotificationSuccess,
  getUrl,
  fetchChatHistory,
  fetchMessagesCounts,
  fetchHRMS,
  messagesJobDetails,
  getCandidateCount,
  markMessageAsRead,
  fetchVmsRequest
} from "../../redux/actions";
import MessageInput from "./components/MessageInput/messageInput";
import ChatHeader from "./components/ChatHeader/chatHeader";
import TopAlert from "../../components/TopNotification/TopAlert";
import WS from "../../webSocket/defaultSocket";
import moment from "moment";
import { types } from "../../redux/action-types";
import InfiniteScroll from "react-infinite-scroll-component";
import { log } from "@antv/g2plot/lib/utils";
import { AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import { canUseSubscriptionFeatures } from "../../shared/billing";

export default function Conversation() {
  const location = useLocation();
  const [conversationsRadioValue, setConversationsRadioValue] =
    useState("all_conversations");
  const [bidTypeRadioValue, setBidTypeRadioValue] = useState("all_bids");
  const [bidTypeName, setBidTypename] = useState("All_Bids");
  const [bidStatusRadioValue, setBidStatusRadioValue] = useState("null");
  const [loadChat, setLoadChat] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [dropDownVisible, setDropDownVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [showHeader, setShowHeader] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const [favCard, setFavCard] = useState(false);
  // Filter Object
  const { id } = useParams()
  const dispatch = useDispatch();
  const dummyRow = [1, 2, 3, 4];
  const favCardHandler = (e) => {
    setFavCard(e);
  };

  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures(userProfile);
  const counts = useSelector((state) => state.messagesReducer.counts);
 const vms = useSelector((state) => state.vmsFilterReducer?.data);
  //hooks***
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [showHistory, setshowHistory] = useState(
    windowDimensions.width > 768 ? false : true
  );
  const [inputWidth, setInputWidth] = useState();
  const [alertMsg, setAlertMsg] = useState();
  const [Recipient, setRecipient] = useState();
  const [title, setTitle] = useState();
  const [conversations, setConversations] = useState([]);
  const [selectedChat, setSelectedChat] = useState();
  // const [jobDetails, setJobDetails] = useState();
  const [createdTime, setCreatedTime] = useState();
  const [errorTitle, setErrorTitle] = useState();
  const [hrmId, sethrmId] = useState(null);
  const [itemId, setItemId] = useState();
  const [vmsId, setVmsId] = useState(null);
  const [Count, setCount] = useState(counts?.data?.totalConversations);

  //REDUCERS***
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const creditsBalanceLoaded = useSelector((state) => state.plansReducer?.creditsBalanceLoaded);
  const inbox = useSelector((state) => state.messagesReducer.inbox);
  const page = useSelector((state) => state.messagesReducer.page);
  const inboxLoading = useSelector(
    (state) => state.messagesReducer.inboxLoading
  );
  const chatDetails = useSelector((state) => state.messagesReducer.chats);
  const jobDetails = useSelector((state) => state.messagesReducer.jobDetail);
  const hasMorechats = useSelector(
    (state) => state.messagesReducer.hasMorechats
  );
  const newMsgInSocket = useSelector(
    (state) => state.messagesReducer.newMsgInSocket
  );

  const { pathname, search, state } = history.location;

  const updatedState = {
    ...state,
    jobOrderId: "",
    jobType: "",
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    dispatch(getUrl());
    dispatch(fetchHRMS(userProfile));
    dispatch(fetchVmsRequest());
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(markMessageAsRead(itemId))
}, [itemId])
  useEffect(() => {
    if (location?.state?.conversationId || id) {
      dispatch(fetchChatHistory(location?.state?.conversationId ?? id));
      setSelectedChat(location?.state?.conversationId ?? id);
    }
    if (location.state?.openConvo && location?.state?.conversationId || id) {
      setshowHistory(true);
    }
    
    if(location?.state?.fromNotification){
      setshowHistory(false);
      setSelectedChat(null);
    }
    
  }, [location?.state || id]);

  useEffect(() => {
    if (chatDetails?.data?.body) {
      dispatch(messagesJobDetails(chatDetails?.data?.body[0]?.GigCard));
      setShowHeader(true);
    }
  }, [chatDetails]);

  useEffect(() => {
    setCount(counts?.data?.totalConversations);
  }, [counts]);

  useEffect(() => {
    if (location?.state?.openConversation == true) {
      // dispatch(
      //   fetchMessagesCounts({
      //     allBids: "all_bids",
      //     jobType: location?.state?.jobType,
      //     jobId: location?.state?.jobOrderId,
      //   })
      // );
      dispatch(
        fetchInboxMessages(
          location?.state?.conversationStatus,
          conversationsRadioValue,
          bidStatusRadioValue,
          null,
          null,
          null,
          true,
          location?.state?.jobType,
          location?.state?.jobOrderId
        )
      );
      setTimeout(() => {
        dispatch(
          fetchInboxMessages(
            location?.state?.conversationStatus,
            conversationsRadioValue,
            bidStatusRadioValue,
            2,
            5,
            null,
            false,
            location?.state?.jobType,
            location?.state?.jobOrderId
          )
        );
      }, 1000);
    } else {
      //if (!location?.state?.fromNotification)
      dispatch(
        fetchInboxMessages(
          location?.state?.conversationStatus,
          conversationsRadioValue,
          bidStatusRadioValue,
          2,
          5,
          null,
          false,
          location?.state?.jobType,
          location?.state?.jobOrderId
        )
      );
    }
  }, []);

  useEffect(() => {
    if (inbox?.data?.data?.body?.conversations) {
      setConversations(inbox?.data?.data?.body?.conversations);
    }
  }, [inbox]);

 const applyFilter = () => {
  // count update
  if (bidTypeRadioValue === "placed_bids") setCount(counts?.data?.allCount?.PlacedBids);
  else if (bidTypeRadioValue === "received_bids") setCount(counts?.data?.allCount?.ReceivedBids);
  else setCount(counts?.data?.totalConversations);
  let vmsFilterValue = null;
  if (vmsId && vms) {
    const selectedVms = vms.find(v => v.VMSLowerName === vmsId);
    if (selectedVms) {
      vmsFilterValue = selectedVms.VMSName;
    }
  }
  dispatch(fetchInboxMessages(
    conversationsRadioValue,
    bidTypeRadioValue,
    bidStatusRadioValue,
    null,
    null,
    hrmId,
    true,
    location?.state?.jobType,
    location?.state?.jobOrderId,
    null,
    null,
    searchValue,
    vmsFilterValue
  ));
  setTimeout(() => {
    dispatch(fetchInboxMessages(
      conversationsRadioValue,
      bidTypeRadioValue,
      bidStatusRadioValue,
      2,
      5,
      hrmId,
      false,
      location?.state?.jobType,
      location?.state?.jobOrderId,
      null,
      null,
      searchValue,
      vmsFilterValue
    ));
  }, 1000);
  setDropDownVisible(false);
  setshowHistory(false);
};
  const clearFilter = () => {
    // dispatch(fetchMessagesCounts("all_bids"));
    setCount(counts?.data?.totalConversations);
    // dispatch(
    // getCandidateCount({
    // bid_type_name: "All_Bids",
    // })
    // );
    setBidStatusRadioValue(() => "null");
    setConversationsRadioValue(() => "all_conversations");
    setBidTypeRadioValue("all_bids");
    setVmsId(null); 
    setshowHistory(false);
    dispatch(
      fetchInboxMessages("null", "all_conversations", null, 1, null, null, true)
    );
    setTimeout(() => {
      dispatch(fetchInboxMessages("null", "all_conversations", "null", 2, 5));
    }, 1000);
    setDropDownVisible(false);
    history?.replace({ pathname, search, state: updatedState });
  };
  const Filters = (
    <Menu className="chat-filter-menu">
<FilterConversations
  vms={vms}
  vmsId={vmsId}
  setVmsId={setVmsId}
  conversationsRadioValue={conversationsRadioValue}
  setConversationsRadioValue={setConversationsRadioValue}
  bidTypeRadioValue={bidTypeRadioValue}
  setBidTypeRadioValue={setBidTypeRadioValue}
  bidStatusRadioValue={bidStatusRadioValue}
  setBidStatusRadioValue={setBidStatusRadioValue}
  sethrmId={sethrmId}
  counts={counts}
  IsHrm={userProfile}
/>

      <div className="statusDropDownBtnss">
        <Button className="clearBtnStatus" onClick={clearFilter}>
          Clear all
        </Button>

        <Button className="applyBtnStatus" onClick={applyFilter}>
          Apply
        </Button>
      </div>
    </Menu>
  );

  
  const onChange = (e) => {
    const value=e.target.value
    let vmsFilterValue = null;
    if (vmsId && vms) {
      const selectedVms = vms.find(v => v.VMSLowerName === vmsId);
      if (selectedVms) {
        vmsFilterValue = selectedVms.VMSName;
      }
    }
    dispatch(
      fetchInboxMessages(
        location?.state?.conversationStatus,
        conversationsRadioValue,
        bidStatusRadioValue,
        1,
        5,
        null,
        true,
        location?.state?.jobType,
        location?.state?.jobOrderId,
        null,
        null,
        value,
        vmsFilterValue
      )
    );
    setTimeout(() => {
      dispatch(
        fetchInboxMessages(
          location?.state?.conversationStatus,
          conversationsRadioValue,
          bidStatusRadioValue,
          2,
          5,
          null,
          false,
          location?.state?.jobType,
          location?.state?.jobOrderId,
          null,
          null,
          value,
          vmsFilterValue
        )
      );
    }, 1000);
    setSearchValue(value);
  };

const fetchMoreData = () => {
  if (hasMorechats) {
    let vmsFilterValue = null;
    if (vmsId && vms) {
      const selectedVms = vms.find(v => v.VMSLowerName === vmsId);
      if (selectedVms) {
        vmsFilterValue = selectedVms.VMSName;
      }
    }
    dispatch(
      fetchInboxMessages(
        conversationsRadioValue,
        bidTypeRadioValue,
        bidStatusRadioValue,
        page,
        5,
        hrmId,
        false,
        location?.state?.jobType,
        location?.state?.jobOrderId,
        true,
        false,
        searchValue,
        vmsFilterValue
      )
    );
  }
};
  const planStatus = creditsBalance?.data?.status || '';
  if (subscriptionFeaturesEnabled && !creditsBalanceLoaded) return <Loader />;
  if (subscriptionFeaturesEnabled && planStatus === 'expired') return (
    <FeatureGate
      featureName="Message"
      iconType="chat"
      description="Your free trial has ended. Choose a plan to continue accessing conversations and messaging with talent."
      bottomText="Message is a paid feature and was given to you for free during your trial period."
    />
  );

  return (
    <div className="conversations-container">
      <TopAlert
        type={"warning"}
        title={errorTitle}
        display={alertMsg && "block"}
        setAlertMsg={setAlertMsg}
      />
      <Row className="conversation">
        <Col className="conversation-div1" lg={8} md={9} xl={7} sm={0} xs={0}>
          <div className="conversation-header">
            {inputWidth ? null : (
              <div className="conversation-header-title">
                <div className="conversation-header-title-text1">
                  All conversations
                </div>
                {/* <div className="conversation-header-title-text2">
                  ({counts?.data?.totalConversations ?? 0})
                </div> */}
              </div>
            )}

            {inputWidth ? null : (
              <Dropdown
                autoFocus={true}
                trigger="click"
                overlay={Filters}
                visible={dropDownVisible}
                onOpenChange={() => setDropDownVisible(!dropDownVisible)}
                className="filterDropdown"
              >
                <div
                  className="conversation-header-filter"
                  onClick={() => setDropDownVisible(!dropDownVisible)}
                >
                  <div className="conversation-header-filter-image">
                    <img src={filterIcon} alt="filterIcon" />
                  </div>
                  <div className="conversation-header-filter-count">

                    {bidStatusRadioValue  == "null"  && hrmId && hrmId != userProfile.AccountId? 3 : bidStatusRadioValue  == "null" ? 3 : 4}

                  </div>
                </div>
              </Dropdown>
            )}

            <div
              className="conversation-header-filter-search"
              onClick={() => setInputWidth(true)}
              style={{
                width: inputWidth ? "81.3%" : "35px",
                transition: inputWidth && "width 1s",
              }}
            >
              <Input
                type={"input"}
                className="conversation-header-input"
                prefix={
                  <SearchOutlined
                    style={{ color: "#7e7e7e", fontSize: "16px" }}
                  />
                }
                placeholder="Find skill listing title or job title"
                allowClear = {inputWidth}
                onChange={debounce((e) => onChange(e))}
              />
              {inputWidth && (
                <div className="cross-icon-div">
                  <CloseOutlined
                    onClick={(event) => {
                      setInputWidth(false);
                      event.stopPropagation();
                    }}
                    style={{ color: "#c4c4c4" }}
                  />
                </div>
              )}
            </div>
          </div>

          <Row className="conversationListCont" id="infinite-scroll-parent">
            {/* {inboxLoading
              ? dummyRow.map((dummy) => {
                return (
                  <Col
                    style={{
                      borderBottom: "1px solid lightgray",
                      width: "100%",
                      padding: "5px",
                    }}
                  >
                    <Skeleton active avatar paragraph={{ rows: 2 }} />
                  </Col>
                );
              })
              :  */}
            <InfiniteScroll
              dataLength={conversations?.length}
              next={fetchMoreData}
              hasMore={hasMorechats}
              scrollableTarget={"infinite-scroll-parent"}
              className={"infinite-scroller"}
              style={{ overflow: "hidden" }}
              loader={
                hasMorechats && conversations?.length > 0 ? (
                  <h4>Loading...</h4>
                ) : inboxLoading ? (
                  <>
                    {dummyRow.map((res, index) => {
                      return (
                        <div key={index} className="shimmer-container">
                          {" "}
                          <Skeleton
                            active
                            avatar
                            paragraph={{ rows: 2 }}
                          />{" "}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <h4>No Conversations</h4>
                )
              }
            >
              {conversations?.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <ConversationCard
                      favCard={favCard}
                      key={index}
                      records={item}
                      // data={message}
                      setCreatedTime={setCreatedTime}
                      // index={index}
                      Index={index}
                      SourceName={
                        item?.SourceTypeId === 1 //SourceTypeName === "SkillListing"
                          ? "Bid"
                          : "Proposal"
                      }
                      setItemId={setItemId}
                      setshowHistory={setshowHistory}
                      setLoadChat={setLoadChat}
                      setRecipient={setRecipient}
                      setTitle={setTitle}
                      title={title}
                      SourceId={item?.BidId}
                      selectedChat={selectedChat}
                      setSelectedChat={setSelectedChat}
                      conversationId={location.state?.conversationId ?? id}
                      jobType={location?.state?.jobType}
                      jobOrderId={location?.state?.jobOrderId}
                    />
                  </Col>
                );
              })}
            </InfiniteScroll>
            {/* } */}
          </Row>
        </Col>

        <Col
          lg={16}
          xl={17}
          md={15}
          sm={24}
          xs={24}
          className={` ${showHistory ? "" : "chat-history-column"} `}
        >
          {showHistory ? (
            <div className="chat-History-Cont">
              <Col className="chatContainer">
                {showHeader && (
                  <ChatHeader
                    setshowHistory={setshowHistory}
                    chatDetails={chatDetails?.data?.body}
                    Recipient={Recipient}
                    createdTime={
                      chatDetails?.data?.body[
                        chatDetails?.data?.body?.length - 1
                      ]?.Created
                    }
                    jobTitle={location?.state?.jobtitle}
                    jobDetails={jobDetails}
                  />
                )}

                <ChatCard
                  setFavCard={favCardHandler}
                  chatDetails={chatDetails?.data?.body}
                  loadChat={loadChat}
                  setLoadChat={setLoadChat}
                  jobDetails={jobDetails}
                  records={location.state?.records}
                  SourceName={location.state?.SourceName}
                  SourceId={location.state?.SourceId}
                  Index={location.state?.Index}
                  Recipient={Recipient}
                />
                <MessageInput
                  setAlertMsg={setAlertMsg}
                  currentUser={userProfile?._id}
                  itemId={location.state?.conversationId ?? id}
                  chatDetails={chatDetails?.data?.body}
                  setErrorTitle={setErrorTitle}
                  jobTitle={jobDetails?.Title}
                />
              </Col>
              {/* {windowDimensions.width > 1000 && (
                <div className="jobDetailCont">
                  <div className="detailsTitle">Gig details</div>
                  <Row className="jobrowflex mr">
                    <div>Location</div>
                    {chatDetails?.data?.body.length > 0 && (
                      <div className="text-Bold">
                        {`${jobDetails?.Cities?.CityName ?? "N/A"}, ${
                          jobDetails?.Regions?.Code ?? "N/A"
                        }`}
                      </div>
                    )}
                  </Row>
                  <Row className="jobrowflex mr">
                    <div>Posted</div>
                    <div className="text-Bold">
                      {jobDetails?.Created
                        ? moment(jobDetails?.Created).format(
                            "ddd, MMM DD, yyyy"
                          )
                        : "N/A"}
                    </div>
                  </Row>
                  <Row className="jobrowflex mr">
                    <div>Expires on</div>
                    <div className="text-Bold">
                      {jobDetails?.ExpiryDate
                        ? moment(jobDetails?.ExpiryDate).format(
                            "ddd, MMM DD, yyyy"
                          )
                        : "N/A"}
                    </div>
                  </Row>
                  <Row className="jobrowflex mr">
                    <div>Gig type</div>
                    <div className="text-Bold">
                      {jobDetails?.JobOrderTypes?.JobOrderTypeName}
                    </div>
                  </Row>
                  {jobDetails?.JobOrderTypes?.JobOrderTypeName ==
                    "Contract" && (
                    <Row className="jobrowflex mr">
                      <div>Contract duration</div>
                      <div className="text-Bold">
                        {
                          jobDetails?.IdealContractLength
                            ?.IdealContractLengthName
                        }
                      </div>
                    </Row>
                  )}
                  <Row className="jobrowflex mr">
                    <div>Work authorization</div>
                    <div className="text-Bold">
                      {jobDetails?.WorkAuthorization}
                    </div>
                  </Row>
                </div>
              )} */}
              {windowDimensions.width > 1000 ?
                <Col className="test-class">
                  {/* {chatDetails?.data?.body &&
                  chatDetails?.data?.body.length &&
                  chatDetails?.data?.body[0].SourceTypeId === 1 && (
                    <Row>
                      {windowDimensions.width > 1000 && (
                        <div className="jobDetailCont">
                          <div className="detailsTitle">
                            Skill listing Details
                          </div>
                          <Row className="jobrowflex mr">
                            <div>Gig Type</div>
                            {chatDetails?.data?.body.length > 0 && (
                              <div className="text-Bold">
                                {`${
                                  chatDetails?.data?.body[0].SkillListingCard
                                    ?.GigType ?? "N/A"
                                }`}
                              </div>
                            )}
                          </Row>
                          <Row className="jobrowflex mr">
                            <div>Skills</div>
                            <div>
                              {chatDetails?.data?.body[0].SkillListingCard
                                ?.SkillListings_Skills &&
                              chatDetails?.data?.body[0].SkillListingCard
                                ?.SkillListings_Skills.length
                                ? chatDetails?.data?.body[0].SkillListingCard?.SkillListings_Skills?.map(
                                    (data, index) => (
                                      <p className="text-Bold-Skills" key={index}>
                                        {data?.SkillName}
                                      </p>
                                    )
                                  )
                                : "N/A"}
                            </div>
                          </Row>
                          <Row className="jobrowflex mr">
                            <div style={{ width: "50%" }}>
                              Willing to relocate
                            </div>
                            <div className="text-Bold-relocate">
                              {chatDetails?.data?.body[0].SkillListingCard
                                ?.SkillListings_Cities &&
                              chatDetails?.data?.body[0].SkillListingCard
                                ?.SkillListings_Cities?.length > 0
                                ? chatDetails?.data?.body[0].SkillListingCard?.SkillListings_Cities?.map(
                                    (data, index) => (
                                      <p className="text-Bold" key={index}>
                                        {data?.Cities?.Location}
                                      </p>
                                    )
                                  )
                                : "N/A"}
                            </div>
                          </Row>
                          {userProfile?.Professions?.ProfessionCode ===
                            "HC" && (
                            <Row className="jobrowflex mr">
                              <div>Desired Salary</div>
                              <div className="text-Bold">
                                $
                                {chatDetails?.data?.body[0].SkillListingCard
                                  ?.MinimumBid?.$numberDecimal ??
                                  chatDetails?.data?.body[0].SkillListingCard
                                    ?.MinimumBid}
                                /
                                {chatDetails?.data?.body[0].SkillListingCard
                                  ?.MinimumBidType == "Year"
                                  ? "YR"
                                  : chatDetails?.data?.body[0].SkillListingCard
                                      ?.MinimumBidType == "Week"
                                  ? "WK"
                                  : "HR"}
                              </div>
                            </Row>
                          )}

                          <Row className="jobrowflex mr">
                            <div>Availability</div>
                            {chatDetails?.data?.body &&
                              chatDetails?.data?.body?.length && (
                                <div className="text-Bold">
                                  {chatDetails?.data?.body[0].SkillListingCard
                                    ?.StartDate
                                    ? moment(
                                        chatDetails?.data?.body[0]
                                          .SkillListingCard?.StartDate
                                      ).format("MMM DD, YYYY")
                                    : "N/A"}
                                </div>
                              )}
                          </Row>
                          <Row className="jobrowflex mr">
                            <div>Experience</div>
                            {chatDetails?.data?.body?.length > 0 && (
                              <div className="text-Bold">
                                {`${
                                  chatDetails?.data?.body[0].SkillListingCard
                                    ?.Profiles?.ExperienceLevelName ?? "N/A"
                                }`}
                              </div>
                            )}
                          </Row>
                          <Row className="jobrowflex mr">
                            <div>Phone No</div>
                            {chatDetails?.data?.body?.length > 0 && (
                              <div className="text-Bold">
                                {`${
                                  chatDetails?.data?.body[0].SkillListingCard
                                    ?.MobilePhone ?? "N/A"
                                }`}
                              </div>
                            )}
                          </Row>
                        </div>
                      )}
                    </Row>
                  )} */}
                  <Row>
                    {
                      <>
                        <div className="jobDetailCont">
                          <div className="detailsTitle">Job details</div>
                          <Row className="jobrowflex mr">
                            <div>Location</div>
                            {chatDetails?.data?.body.length > 0 && (
                              <div className="text-Bold">
                                {`${jobDetails?.Cities?.CityName ?? "N/A"}, ${jobDetails?.Regions?.Code ?? "N/A"
                                  }`}
                              </div>
                            )}
                          </Row>
                          <Row className="jobrowflex mr">
                            <div>Posted</div>
                            <div className="text-Bold">
                              {jobDetails?.Created
                                ? moment(jobDetails?.Created).format(
                                  "dddd, MMMM DD, YYYY" )
                                : "N/A"}
                            </div>
                          </Row>
                          <Row className="jobrowflex mr">
                            <div>Expires</div>
                            <div className="text-Bold">
                              {jobDetails?.ExpiryDate
                                ? moment(jobDetails?.ExpiryDate).format(
                                  "dddd, MMMM DD, YYYY"
                                )
                                : "N/A"}
                            </div>
                          </Row>
                          <Row className="jobrowflex mr">
                            <div>Job type</div>
                            <div className="text-Bold">
                              {jobDetails?.JobOrderTypes?.JobOrderTypeName}
                            </div>
                          </Row>
                          {jobDetails?.JobOrderTypes?.JobOrderTypeName ==
                            "Contract" && (
                              <Row className="jobrowflex mr">
                                <div>Contract duration</div>
                                <div className="text-Bold">
                                  {
                                    jobDetails?.IdealContractLength
                                      ?.IdealContractLengthName
                                  }
                                </div>
                              </Row>
                            )}
                          <Row className="jobrowflex mr">
                            <div>Work authorization</div>
                            <div className="text-Bold">
                              {jobDetails?.WorkAuthorization &&
                                jobDetails?.WorkAuthorization?.length > 0
                                ? jobDetails?.WorkAuthorization?.map((i, index) => {
                                  if (jobDetails?.WorkAuthorization?.length > 1) {
                                    if (
                                      index !==
                                      jobDetails?.WorkAuthorization?.length - 1
                                    ) {
                                      return <div className="horizontalLine-Conversation">
                                        {i + ","}
                                      </div>
                                    }
                                  }
                                  return <div className="horizontalLine-Conversation">
                                    {i}
                                  </div>
                                })
                                : "N/A"}
                            </div>
                          </Row>
                        </div>
                      </>
                    }
                  </Row>
                </Col> : null}
            </div>
          ) : (
            <div className="iconChatCont">
              <div className="iconnChat">
                <img
                  src={chatIcon}
                  alt="chatIcon"
                  className="iconConversation"
                />
              </div>
              <div className="iconChatTitle">
                {conversations.length > 0
                  ? "Choose a conversation"
                  : "No conversation"}
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}
